/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Version
 */
export interface Version {
    /**
     * 
     * @type {string}
     * @memberof Version
     */
    timestamp: string;
    /**
     * 
     * @type {string}
     * @memberof Version
     */
    branch: string;
    /**
     * 
     * @type {string}
     * @memberof Version
     */
    checksum: string;
    /**
     * 
     * @type {string}
     * @memberof Version
     */
    version: string;
}

/**
 * Check if a given object implements the Version interface.
 */
export function instanceOfVersion(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "branch" in value;
    isInstance = isInstance && "checksum" in value;
    isInstance = isInstance && "version" in value;

    return isInstance;
}

export function VersionFromJSON(json: any): Version {
    return VersionFromJSONTyped(json, false);
}

export function VersionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Version {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timestamp': json['timestamp'],
        'branch': json['branch'],
        'checksum': json['checksum'],
        'version': json['version'],
    };
}

export function VersionToJSON(value?: Version | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timestamp': value.timestamp,
        'branch': value.branch,
        'checksum': value.checksum,
        'version': value.version,
    };
}

